import "./index.css";

const ThreeDotsLoading = () => {
  return <div className="three-dots-loader"></div>;
};

export default ThreeDotsLoading;
